<template>
	<div class="suggested-post" v-if="hasPosts">
		<div class="suggested-post-image" v-if="hasPosts">
			<img :src="[scaledImage]" />
		</div>
		<div class="suggested-post-text" v-if="hasPosts">
			<h4 class="suggested-post-title">{{ title }}</h4>
			<p class="suggested-post-content">{{ content }}</p>
		</div>
	</div>
	<div v-else class="suggested-post-no-post">
		<div class="suggested-post-text no-posts-message">
			<font-awesome-icon
				:icon="['fal', 'calendar-day']"
				class="suggested-post-icon"
			/>
			<p class="suggested-post-content no-posts-message-content">
				There are no suggested posts for this day.
				<button
					class="no-posts-message-content-link"
					data-test="create-post"
					@click="handleCreateClick"
				>
					Create Custom Post.
				</button>
			</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SuggestedPost',
	props: {
		image: String,
		title: String,
		content: String,
	},
	computed: {
		hasPosts() {
			return this.image || this.title || this.content;
		},
		scaledImage() {
			return this.image.replace('upload/', 'upload/w_150/');
		},
	},
	methods: {
		handleCreateClick(e) {
			this.$emit('createPostClick');
		},
	},
};
</script>

<style lang="scss" scoped>
.suggested-post {
	@include rem(padding, 15px);
	border: $b360-border-width-thin solid $border-color-light;
	border-radius: $b360-border-radius-base;
	display: grid;
	grid-template-columns: 150px 1fr;
	grid-gap: 15px;
	cursor: default;

	&-image {
		display: inline-block;
		overflow: hidden;
		line-height: 0;
		border-radius: $b360-border-radius-base;
		width: 150px;
		height: 150px;

		img {
			border-radius: $b360-border-radius-base;
			width: 100%;
			height: auto;
		}
	}

	&-title {
		margin: 0 0 10px;
	}

	&-content {
		font-size: $b360-font-size--smaller;
	}
	&-icon {
		color: $brand-blue;
		width: 40px;
		font-size: 30px;
	}
}
.suggested-post-no-post {
	@include rem(padding, 15px);
	border: $b360-border-width-thin solid $border-color-light;
	border-radius: $b360-border-radius-base;
	display: grid;
	grid-template-columns: 150px 1fr;
	grid-gap: 15px;
	cursor: default;
}
.no-posts-message {
	grid-column: span 2 / auto;
	display: inline-block;
	text-align: center;
	cursor: default;

	&-content {
		margin-bottom: 0 !important;
		padding-bottom: 0 !important;
		align-self: center;

		&-link {
			color: $brand-blue;
			background-color: transparent;
			border: none;
			padding: 0;
			font-size: $b360-font-size--smaller;
			cursor: pointer;
		}
	}
}

.suggested-posts-date-item {
	@media (max-width: 651px) {
		.suggested-post-image {
			text-align: center;
		}
	}
	@media (min-width: $breakpoint+1px) and (max-width: 1291px) {
		.suggested-post-image {
			text-align: center;
		}
	}
}
</style>
